<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 1/11/2020
  -->

<!-- eslint-disable vue/no-mutating-props -->

<template>
	<div class="m-4 qwoach-form client-profile-view-root">
		<div v-if="!hideName" class="mb-3">
			<div class="row align-items-center m-0">
<!--				<el-avatar :size="60"></el-avatar>-->
				<div class="col">
					<BackHeader @click="onBackPressed">
						<h1 class="d-inline">{{clientProfile.name}}</h1>
					</BackHeader>

					<div class="row mx-0 mb-4 align-items-center">
						<span class="mr-3">Tags</span>
						<SuggestionsTagsView
							v-model="clientProfile.tagItemsArray"
							@change="onDataChanged('tags', {tags_count: clientProfile.tagItemsArray.length})"/>
					</div>
					<div class="row">
						<div class="col">
							<TitledRow
								title="Email:">
								<a :href="clientProfile.mailToHref()" target="_blank">{{clientProfile.email}}</a>
							</TitledRow>
							<TitledRow
								title="Birthday:">
								<el-date-picker
									class="w-50"
									v-model="clientProfile.dateOfBirth"
									@change="onDataChanged('dateOfBirth')"
									value-format="timestamp"
									type="date"
									placeholder="Pick a day">
								</el-date-picker>
							</TitledRow>
							<TitledRow
								title="Phone:">
								<qw-input class="w-50"
										  placeholder="phone number"
										  v-model="clientProfile.phone"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('phone')"/>
							</TitledRow>
							<TitledRow
								title="Tax ID:">
								<qw-input class="w-50"
										  placeholder="tax id"
										  v-model="clientProfile.taxId"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('tax id')"/>
							</TitledRow>
							<TitledRow
								title="Mailing Address:">
								<qw-input class="w-50"
										  placeholder="mailing address"
										  v-model="clientProfile.mailingAddress"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('mailing address')"/>
							</TitledRow>
						</div>
						<div class="col">

						</div>
					</div>


					<hr class="w-100"/>

					<div class="row">
						<div class="col">
							<div class="profile-subtitle">
								Personal
							</div>
							<TitledRow
								title="Spouse Name:">
								<qw-input class="w-50"
										  v-model="clientProfile.personalInfo.spouseName"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('spouse name')"/>
							</TitledRow>
							<TitledRow
								title="Children's Names:">
								<qw-input class="w-50"
										  v-model="clientProfile.personalInfo.childrenNames"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('children names')"/>
							</TitledRow>

						</div>
						<div class="col">
							<div class="profile-subtitle">
								Social media
							</div>

							<TitledRow
								title="Facebook:">
								<qw-input class="w-50"
										  placeholder="Facebook profile url"
										  v-model="clientProfile.socialMedia.facebookUrl"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('facebook url')"
								></qw-input>
							</TitledRow>
							<TitledRow
								title="LinkedIn:">
								<qw-input class="w-50"
										  placeholder="LinkedIn profile url"
										  v-model="clientProfile.socialMedia.linkedInUrl"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('linkedin url')"/>
							</TitledRow>
							<TitledRow
								title="YouTube:">
								<qw-input class="w-50"
										  placeholder="YouTube profile url"
										  v-model="clientProfile.socialMedia.youtubeUrl"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('youtube url')"/>
							</TitledRow>
							<TitledRow
								title="Twitter:">
								<qw-input class="w-50"
										  v-model="clientProfile.socialMedia.twitterUrl"
										  placeholder="Twitter profile url"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('twitter url')"/>
							</TitledRow>
							<TitledRow
								title="Instagram:">
								<qw-input class="w-50"
										  v-model="clientProfile.socialMedia.instagramUrl"
										  placeholder="Instagram profile url"
										  :input-debounce-delay="1000"
										  @change="onDataChanged('instagram url')"/>
							</TitledRow>
						</div>

					</div>



					<hr class="w-100"/>
					<div class="profile-subtitle">
						Private notes
					</div>

					<!--					<datepicker placeholder="Select Date"></datepicker>-->
<!--					<datepicker @selected="onMilestonePicked({command:'byDate', itemId: billingItem.id, index: index, data:$event} )"></datepicker>-->

				</div>
			</div>
		</div>

        <NotesView
            :analytics-props="analyticsPropsMethod()"
            :noteList="noteList"
            @createNote="createNote"
            @updateNote="updateNote"
            @deleteNote="deleteNote"/>

		<qw-button type="warn"
				   v-if="showEnableClientButton"
				   @click="onEnableClientClicked"
				   :analytics-props="analyticsPropsMethod()">
			<span v-if="clientProfile.isEnabled">
				Disable Client
			</span>
			<span v-else>
				Enable Client
			</span>
		</qw-button>
		<qw-button type="danger"
				   v-if="shouldShowDeleteButton"
				   @click="onDeleteClientClicked"
				   :analytics-props="analyticsPropsMethod()">
			Delete client
		</qw-button>

		<LoadingIndicator/>
	</div>

</template>

<script>

	import moment from 'moment'

	import NotesView from "@/core/modules/Notes/view/NotesView.vue"

	import ClientProfile from "@shared/Profile/ClientProfile";
	import TitledRow from "@/core/components/TitledRow.vue";
	import SuggestionsTagsView from "@/core/components/Tags/SuggestionsTagsView.vue";

	import BackHeader from "@/core/components/BackHeader.vue";
	import QwInput from "@/core/components/Controls/QwInput.vue";
	import BaseComponent from "@/core/components/BaseComponent.vue";
	import LoadingIndicator from "@/core/components/LoadingIndicator.vue";

	export default {
		name: 'ClientProfileView',
		extends: BaseComponent,
		components: {
			LoadingIndicator,
			QwInput,
			BackHeader,
			SuggestionsTagsView,
			TitledRow,
			NotesView
		},
		props: {
			clientProfile: ClientProfile,
			hideName: {type: Boolean, default: false},
			showEnableClientButton: Boolean
		},
		data() {
			return {
				noteList: []
			}
		},


		computed: {

			shouldShowDeleteButton(){
				let deleteClientClickedListener = this.findListenerByName("deleteClientClicked")
				return deleteClientClickedListener != null
			},

			// ...mapState({
			// 	noteListAll: state => state.firebaseStore.notes
			// }),
			//
			// noteList: {
			// 	cache: false,
			// 	get() {
			// 		return this.noteListAll[this.clientProfile.id] || []
			// 	}
			// },


		},


		methods: {

			onBackPressed(){
				this.$emit("backPressed")
			},

			async loadNotes(){
				this.noteList = await this.handleAsync(() => this.$dataManager.getNoteListByOwnerId(this.clientProfile.id))
			},

			async onDataChanged(dataName, props = {}){
				await this.handleAsync(async () => {
					await this.onDataSave(dataName, props)
					this.toast("All changes saved")
				})
			},

			async onDataSave(dataName, props = {}){
				let _ = this.$analyticManager.trackEvent("Client property changed", {property_name: dataName, ...props, ...this.analyticsPropsMethod()})
				return this.$dataManager.updateClientProfile(this.clientProfile)
			},

			async createNote(note) {
				note.ownerIds.push(this.clientProfile.id)
				let res = await this.handleAsyncNonBlocking(() => this.$dataManager.createNote(note))
				if(res){
					this.noteList.unshift(note)
				}

			},
			async updateNote(note) {
				await this.handleAsync(() => this.$dataManager.updateNote(note))
			},
			async deleteNote(note) {
				let res = await this.handleAsyncNonBlocking(() => this.$dataManager.deleteNote(note), {default: true})
				if(res){
					this.noteList.deleteItem(note, (l, r) => l.id === r.id)
				}
			},

			analyticsPropsInternal(){
				return {
					category: "Client profile",
					client_id: this.clientProfile.id
				}
			},

			async onDeleteClientClicked(){
				await this.handleAsync(this.emitPromise("deleteClientClicked"))
			},

			async onEnableClientClicked(){
				await this.handleAsync(async () => {
					let isEnabled = !this.clientProfile.isEnabled
					await this.$dataManager.apiPostSetClientEnabled({profileData: this.clientProfile, isEnabled})
					this.clientProfile.isEnabled = isEnabled
					await this.emitPromise("onChange")
				})
			},

		},

		created() {

			this.loadNotes()
			// this.progressDataLoading()
			// 	.for(() => this.$server.getNoteList(this.clientProfile.id))
			// 	.then(notes => {
			// 		console.log("noteList = ", notes)
			// 		this.$forceUpdate()
			// 	}).catch(error => {
			// 	this.handleError(error, "Can't load notes. Please try reload the page or contact support.")
			// })
		},


	}
</script>


<style lang="scss">

.client-profile-view-root{
	hr {
		margin-top: 20px;
		margin-bottom: 40px;
	}

	.profile-subtitle{
		font-weight: 600;
		margin-bottom: 15px;
	}
}


	/*textarea {*/
	/*	border: none !important;*/
	/*}*/

	/**/
</style>



